import { useMemo } from 'react';

import { PROJECT_TYPE } from 'src/data/project';

import { useRecentlyUsedTemplatesCards } from '../templates/useRecentlyUsedTemplatesCards';

// TODO: we should really pass `customToolData` and `subTemplateData` as objects into a card, not spread them
export const useDocumentRecentlyUsedTools = () => {
  const recentlyUsedTemplatesCards = useRecentlyUsedTemplatesCards();

  return useMemo(() => {
    // take only "document" templates
    const documentCards = recentlyUsedTemplatesCards.filter(
      (card) => card.projectType === PROJECT_TYPE.document
    );

    // map them to tools and group by generation tool
    const tools = documentCards.map((card) => {
      if (card.customToolData) {
        return {
          tool: card.generationTool,
          ...card.customToolData,
        };
      }

      if (card.subTemplateData) {
        return {
          tool: card.generationTool,
          ...card.subTemplateData,
        };
      }

      return {
        tool: card.generationTool,
      };
    });

    return [{ toolGroup: null, tools }];
  }, [recentlyUsedTemplatesCards]);
};
